import dayjs from 'dayjs'

const format = 'YYYY-MM-DD'
export const normalizeDate = (date: string | Date) => dayjs(date).format(format)
